var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.684,
    height: 36.684,
    viewBox: "0 0 36.684 36.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M13.868,5a1.623,1.623,0,0,0-1.622,1.622v9.24L9.275,20.32a1.622,1.622,0,0,0,2.7,1.8l3.244-4.866a1.627,1.627,0,0,0,.272-.9V6.622A1.623,1.623,0,0,0,13.868,5Z",
    transform: "translate(4.974 2.488)",
    fill: "#029c27",
    stroke: "#029c27",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M18.832,1C7.373,1.071,1,7.514,1,18.813S7.378,36.684,18.852,36.684c11.617,0,17.616-6.061,17.832-17.869C36.486,7.4,30.153,1.073,18.832,1Zm.019,32.44c-9.774-.057-14.416-4.7-14.608-14.6C4.427,9.079,9.206,4.3,18.832,4.244c9.526.062,14.441,4.983,14.608,14.567-.182,9.922-4.824,14.57-14.588,14.629Z",
    fill: "#029c27",
    stroke: "#029c27",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ede27c9f5ddb5b59e2391ad62cde6b30.svg";
export { ForwardRef as ReactComponent };